import { render } from "./AppButton.vue?vue&type=template&id=9bd630f8&ts=true"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=9bd630f8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__